"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var react_1 = require("swiper/react");
var modules_1 = require("swiper/modules");
var SwiperNavArrows_1 = require("../../Swiper/SwiperNavArrows");
var ReviewCarouselMain = function (_a) {
    var reviews = _a.reviews, color = _a.color, readMore = _a.readMore;
    // Add pagination if if readMore doesn't exist
    var modules = [modules_1.Navigation];
    if (!readMore) {
        modules.push(modules_1.Pagination);
    }
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)(react_1.Swiper, { className: "product-reviews swiper-carousel--".concat(color), modules: modules, pagination: { clickable: true }, slidesPerView: 1.2, loop: true, centeredSlides: true, centerInsufficientSlides: true, spaceBetween: 18, breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1025: {
                    slidesPerView: 2.8,
                },
                1600: {
                    slidesPerView: 4,
                },
            } },
            (0, preact_1.h)(SwiperNavArrows_1.default, { color: color }),
            reviews.map(function (review, index) { return ((0, preact_1.h)(react_1.SwiperSlide, { key: index },
                (0, preact_1.h)("div", { class: "product-reviews__review" },
                    (0, preact_1.h)("div", { class: "product-reviews__header" },
                        (0, preact_1.h)("div", { class: "product-reviews__stars" }, "\u2605\u2605\u2605\u2605\u2605"),
                        (0, preact_1.h)("p", { class: "product-reviews__title" }, review.title)),
                    (0, preact_1.h)("p", { class: "product-reviews__body" }, review.body),
                    (0, preact_1.h)("p", { class: "product-reviews__author" }, review.author),
                    review.logo && ((0, preact_1.h)("div", { class: "product-reviews__logo" },
                        (0, preact_1.h)("img", { class: "product-reviews__logo-image", src: review.logo, alt: "product logo" })))))); }),
            readMore && ((0, preact_1.h)("div", { class: "product-reviews__easy-access" },
                (0, preact_1.h)("a", { class: "product-reviews__easy-access-btn", href: readMore }, "Read More Reviews"))))));
};
exports.default = ReviewCarouselMain;
